import { fetchBedbankOfferById } from 'actions/BedbankOfferActions'
import { fetchExperienceIds } from 'actions/ExperienceActions'
import { fetchOffersById } from 'actions/OfferActions'
import { fetchCruiseOffer } from 'actions/CruiseActions'
import { fetchTourV2Offer } from 'actions/tour/TourV2Actions'
import type { AppAction } from 'actions/types/ActionTypes'
import type { UnresolvedLuxPlusCartOffer } from './cartMachineUtils'

/**
 * Loads offers the membership cleanup still needs, using the existing per-type fetchers.
 * Loaded and in-flight ids are skipped. A failed id is requested again, so a later visibility refresh can recover.
 */
export function fetchLuxPlusCartCleanupOffers(offers: Array<UnresolvedLuxPlusCartOffer>): AppAction {
  return (dispatch) => {
    const hotelOfferIds: Array<string> = []
    const experienceOfferIds: Array<string> = []

    offers.forEach((offer) => {
      switch (offer.itemType) {
        case 'hotel':
        case 'villa':
        case 'accommodationV2':
          hotelOfferIds.push(offer.offerId)
          break
        case 'bedbankHotel':
          dispatch(fetchBedbankOfferById(offer.offerId))
          break
        case 'tourV2':
          dispatch(fetchTourV2Offer(offer.offerId, offer.privateRequestKey, undefined, undefined, true))
          break
        case 'cruise':
          dispatch(fetchCruiseOffer(offer.offerId))
          break
        case 'experience':
          experienceOfferIds.push(offer.offerId)
          break
      }
    })

    if (hotelOfferIds.length > 0) {
      dispatch(fetchOffersById(hotelOfferIds, { retryFailed: true }))
    }
    if (experienceOfferIds.length > 0) {
      dispatch(fetchExperienceIds(experienceOfferIds, { retryFailed: true }))
    }
  }
}
